import entity from './reducers';

import * as entityOperations from './operations';
import * as entityTypes from './types';

export { entityOperations, entityTypes };
export default entity;
